import { getJobsBoardLayout } from '@layouts/JobsBoardLayout';
import { JobsBoardView } from '@views/jobsBoard';

const JobsBoardPage = () => {
  return <JobsBoardView />;
};

JobsBoardPage.isPublic = true;
JobsBoardPage.getLayout = getJobsBoardLayout;

export default JobsBoardPage;
